import { BIRDVIEW_META_SEPARATOR } from '../../DashboardBirdview.constants'
import { BIRDVIEW_CHART_FLOW_SERIES } from '../../DashboardBirdview.constants.charts'
import { formatBirdviewChartDateRange } from '../../DashboardBirdview.utils.charts'

// The 90-day window can cut its first and its last week short.
export function getBirdviewFlowTooltipTitle({ payload, t }) {
  const point = payload[0].payload

  return [
    formatBirdviewChartDateRange(point),
    point.isPartial ? t('DashboardBirdview.ChartPartialWeekKey') : null,
  ]
    .filter(Boolean)
    .join(BIRDVIEW_META_SEPARATOR)
}

export function getBirdviewFlowTooltipRows({ payload, t }) {
  return BIRDVIEW_CHART_FLOW_SERIES.map(series => ({
    color: series.color,
    id: series.dataKey,
    isStrong: true,
    label: t(series.labelKey),
    value: payload.find(item => item.dataKey === series.dataKey)?.value,
  }))
}
